module.exports = __webpack_public_path__ + "static/media/SOUP-BNB.6a6d3654.svg";